import { styled } from '@mui/material/styles';
import { TextTooltip } from './tooltip';

export const TooltipStyle = styled(TextTooltip)({
  overflow: 'hidden',
  outline: 'none'
});

export const TooltipStyles = {
  tooltip: {
    sx: {
      backgroundColor: 'gray',
      fontSize: '14px'
    }
  }
};

export const ImageTooltipStyles = {
  tooltip: {
    sx: {
      backgroundColor: 'transparent'
    }
  }
};

export const TooltipShortText = styled(TooltipStyle)({
  width: '180px',
  height: '36px',
  WebkitLineClamp: 2
});

export const TooltipLongText5Rows = styled(TooltipStyle)({
  width: '360px',
  height: '85px',
  marginBottom: '32px',
  WebkitLineClamp: 5
});

export const TooltipLongText2Rows = styled(TooltipStyle)({
  width: '360px',
  height: '35px',
  WebkitLineClamp: 2,
  marginBottom:'13px'
});

export const ListTooltipStyle = styled(TooltipStyle)({
  maxWidth: '180px',
  WebkitLineClamp: 1
});

export const TooltipDisplayName = styled(TooltipStyle)({
  width: '180px',
  WebkitLineClamp: 2
});
